export enum ModifyScopeType {
    NONE = "NONE",
    EXCEPT_ASSESSMENT_SET = "EXCEPT_ASSESSMENT_SET",
    ALL = "ALL"
}
